const { fetchJsonApi } = require('./abstract');

const versionPrefix = 'v2';

function fetchUserRanking(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: `${versionPrefix}/statistics/userRanking`,
    expectedStatus: 200,
    description: 'Fetching user ranking',
  });
}

module.exports = {
  fetchUserRanking,
};
